<template>
  <el-dialog
    title="升级"
    :visible.sync="dialogVisible"
    customClass="customWidth"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="mini"
    >
      <el-form-item
        prop="legal"
        label="代理名称"
      >
        {{userName}}
      </el-form-item>
      <el-form-item
        prop="userName"
        label="代理级别"
      >
        三级代理
      </el-form-item>
      <el-form-item
        prop="prov_cd"
        label="升级为"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.prov_cd"
                placeholder="请选择"
        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>




    <el-form-item>
      <el-button
              type="primary"
              :loading="loading"
              @click="saveUser"
      >保存</el-button>
      <el-button @click="close">取消</el-button>
    </el-form-item>
    </el-form>
  </el-dialog>

</template>
<style>
  .customWidth{
    width:80%;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js';
export default {
  name: "twoagentyEditForm",
  props: {
      oneagent: Object,
    value: Boolean
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
        userName:"",
      form: {
          prov_cd:""
      },
        typeOptions: [   {
            value: "0",
            label: "一级代理"
        },{
            value: "1",
            label: "二级代理"
        }]
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
      if (this.oneagent.userId) {

          this.userName = this.oneagent.agentname;

      } else {
        this.form = {};
      }

    },
      saveUser() {
          this.$refs["form"].validate(valid => {
              if (valid) {
                  if (this.oneagent.userId) {
                      this.loading = true;
                      agentService.savePagentidDltype({ ...this.form,agentid:this.oneagent.agentid})
                          .then(data => {
                              this.loading = false;
                              this.dialogVisible = false;
                              this.$emit("submit");
                          });
                  }
              } else {
                  return false;
              }
          });
      },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

